class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);

    // select all properties[materiaali] and properties[jalka] fields
    var $product_prop_selector = $('[name="properties[materiaali]"],[name="properties[Kätisyys]"]');
    var $product_prop_selector_legs = $('[name="properties[jalka]"]');
    var $fabricsTitle = $('[name="properties[materiaali]"]');
    var $legsTitle = $('[name="properties[jalka]"]');
    var $sideSelectorTitle = $('[name="properties[Kätisyys]"]');

     //new code 4/5/23
    let api;

    // Listen for the event.
    window.addEventListener('sayduck.api-ready', (event) => {
      console.log("hello Sayduck is awake! ")
      api = event.detail.instance
  });

    // Dispatch the event.
    /*this.addEventListener('sayduck.api-ready', function(event){
      console.log("hello Sayduck is awake! ")
      api = event.detail.instance; });*/
   /* $(document).on('sayduck.api-ready', function(event){
      console.log("hello Sayduck is awake! ")
      api = event.detail.instance; });*/
    //end new code 4/5/23

    //$(document).on('sayduck.viewer.gltf.loaded', function(){console.log("tulostaa")});

    //$(document).on('sayduck.configurator.selectedConfigurationUpdated', function(e){console.log("tulostaa", e)});

    $product_prop_selector_legs.on('change', function() {
      //new code 4/5/23
     // api.configurator.setActiveByUuid("e4611290-554d-0138-d97e-7af0ba287a84");

      // map all selected properties[materiaali] and properties[jalka] fields\
        
        var props_map = $product_prop_selector_legs.filter(':checked').map(function(e) {
        var variant_id = $(this).data('variant-id');
        if (variant_id) return variant_id;
        });
        console.log("props_map", props_map)
        var uuid_to_pass = props_map[0].replace(/\'/g,"").replace(/\’/g,"");

      //variant change value for showing customer what fabric is checked
        var fabricsTitleChecked = $fabricsTitle.filter(':checked').val();
        var fabricsImageUrl = $fabricsTitle.filter(':checked').data('img-url');

      //variant change value for showing customer what leg is checked
        var legsTitleChecked = $legsTitle.filter(':checked').val();
        var legsImageUrl = $legsTitle.filter(':checked').data('img-url');

      //variant change value for showing customer what side selection is checked
      var sideSelectorTitleChecked = $sideSelectorTitle.filter(':checked').val();
      /*var sideSelectorsImageUrl = $sideSelectorTitle.filter(':checked').data('img-url');*/

        
        $('.selected-fabrics__title').html(fabricsTitleChecked);
        $('.selected-legs__title').html(legsTitleChecked);
        //$('.selected-side-selectable__title').html(sideSelectorTitleChecked);

        $('#selected-fabric-img').attr("src", fabricsImageUrl);
        $('#selected-leg-img').attr("src", legsImageUrl);

        $("#show_fabrics_button").html($("#selected_fabrics_container"))
        $("#show_components_button").html($("#selected_legs_container"))

        $('.selected-variant').show();
        if(uuid_to_pass == "no_visualizer") return;

      api.configurator.setActiveByUuid(uuid_to_pass);
    });
    $product_prop_selector.on('change', function() {
      //new code 4/5/23
     // api.configurator.setActiveByUuid("e4611290-554d-0138-d97e-7af0ba287a84");

      // map all selected properties[materiaali] and properties[jalka] fields\
        
        var props_map = $product_prop_selector.filter(':checked').map(function(e) {
          console.log("this", this)
        var variant_id = $(this).data('variant-id');
        if (variant_id) return variant_id;
        });
        var uuid_to_pass = props_map[0].replace(/\'/g,"").replace(/\’/g,"");

      //variant change value for showing customer what fabric is checked
        var fabricsTitleChecked = $fabricsTitle.filter(':checked').val();
        var fabricsImageUrl = $fabricsTitle.filter(':checked').data('img-url');

      //variant change value for showing customer what leg is checked
        var legsTitleChecked = $legsTitle.filter(':checked').val();
        var legsImageUrl = $legsTitle.filter(':checked').data('img-url');

      //variant change value for showing customer what side selection is checked
      var sideSelectorTitleChecked = $sideSelectorTitle.filter(':checked').val();
      /*var sideSelectorsImageUrl = $sideSelectorTitle.filter(':checked').data('img-url');*/

        
        $('.selected-fabrics__title').html(fabricsTitleChecked);
        $('.selected-legs__title').html(legsTitleChecked);
        //$('.selected-side-selectable__title').html(sideSelectorTitleChecked);

        $('#selected-fabric-img').attr("src", fabricsImageUrl);
        $('#selected-leg-img').attr("src", legsImageUrl);

        $("#show_fabrics_button").html($("#selected_fabrics_container"))
        $("#show_components_button").html($("#selected_legs_container"))

        $('.selected-variant').show();
        if(uuid_to_pass == "no_visualizer") return;

      api.configurator.setActiveByUuid(uuid_to_pass);
    });

      /* Fabrics click */
      $('#show_fabrics_button').click(function () {
      $('#fabrics_container').animate({
        height: 'toggle'
        });
      })

      /* Legs click */
    $('#show_components_button').click(function () {
    $('#component_container').animate({
      height: 'toggle'
      });
      })

  }

  onVariantChange(e) {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.updateInventoryStatus();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    this.updatePehmeys(); //custom code: Added by Plentiful Commerce 1 Feb 2023
      //this.updateSayduckViewer(); 
      //custom code: Added by Plentiful Commerce 3 Feb 2023
    this.updateQuantityToggle();
    this.updateSveaPaymentMethod();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }
  formatMoney(cents, format) {
    const money_format = "{{amount}}";

    if (typeof cents == 'string') { cents = cents.replace('.',''); }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || money_format);
  
    function defaultOption(opt, def) {
       return (typeof opt == 'undefined' ? def : opt);
    }
  
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');
  
      if (isNaN(number) || number == null) { return 0; }
  
      number = (number/100.0).toFixed(precision);
  
      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1'),
          cents   = parts[1] ? (decimal + parts[1]) : '';
  
      return dollars + cents;
    }
  
    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 2, 0, '.');
        break;
    }
  
    return formatString.replace(placeholderRegex, value);
  };
  updateSveaPaymentMethod() { 
    document.dispatchEvent(new CustomEvent("svea-partpayment-calculator-update-price", { "detail": { "price": this.formatMoney(this.currentVariant.price, '{{amount_no_decimals_with_comma_separator}}') } }));
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateSayduckViewer = () => {
    // select all properties[materiaali] and properties[jalka] fields
    var $product_prop_selector = $('[name="properties[materiaali]"],[name="properties[jalka]"]', $container);
    var $fabricsTitle = $('[name="properties[materiaali]"]');
    var $legsTitle = $('[name="properties[jalka]"]');
    $(document).on('sayduck.viewer.gltf.loaded', function(){console.log("tulostaa")});
    $(document).on('sayduck.configurator.selectedConfigurationUpdated', function(e){console.log("tulostaa", e)});

    $product_prop_selector.on('change', function() {


      // map all selected properties[materiaali] and properties[jalka] fields
        var props_map = $product_prop_selector.filter(':checked').map(function(e) {
        var variant_id = $(this).data('variant-id');
        if (variant_id) return variant_id;
        });

      //variant change value for showing customer what fabric is checked
        var fabricsTitleChecked = $fabricsTitle.filter(':checked').val();
        var fabricsImageUrl = $fabricsTitle.filter(':checked').data('img-url');

      //variant change value for showing customer what leg is checked
        var legsTitleChecked = $legsTitle.filter(':checked').val();
        var legsImageUrl = $legsTitle.filter(':checked').data('img-url');

        
        $('.selected-fabrics__title').html(fabricsTitleChecked);
        $('.selected-legs__title').html(legsTitleChecked);

        $('#selected-fabric-img').attr("src", "https:".concat(fabricsImageUrl));
        $('#selected-leg-img').attr("src", "https:".concat(legsImageUrl));
        

        $("#show_fabrics_button").html($("#selected_fabrics_container"))
        $("#show_components_button").html($("#selected_legs_container"))

        $('.selected-variant').show();
        
      // convert the map containing jquery objects into array
        var props_arr = $.makeArray(props_map);

      // if not all props collected exit the function
        if(props_arr.length < 2) return;


      // construct details json, replace ' with " to get valid json
        var details_json = '{'.concat(props_arr.join(',')).concat('}').replace(/\'/g,"\"");

      // construct the proper details
      var details_obj = Object.assign({}, {"detail": JSON.parse(details_json)});

      // TODO: Properly send the constructed details object to SayDuck

      window.dispatchEvent(new CustomEvent('sayduck.configurator.actions.updateSelectedConfiguration', details_obj));

      /*document.addEventListener('sayduck.viewer.gltf.loaded', function() {
        window.dispatchEvent(new CustomEvent('sayduck.configurator.actions.updateSelectedConfiguration', details_obj));
      }, false);*/


  });
  }
  //custom code: Added by Plentiful Commerce 1 Feb 2023 
  GivePehmeysVideos = (url1, url2) => {
    let pehmeys_videos = "";
    if(url1.length !== 0) {
      pehmeys_videos =  `<div class="video-wrapper"><iframe width="560" height="315" src="${url1}" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""></iframe></div>`;
    }
    if(url2.length !== 0) {
      pehmeys_videos += `<div class="video-wrapper"><iframe width="560" height="315" src="${url2}" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""></iframe></div>`;
    }
    return pehmeys_videos;
  }
 
  //To check which option index has the Pehmeys type
  checkIfPehmeysInOptions = (pehmeys_type_1, pehmeys_type_2, pehmeys_type_3, pehmeys_type_4, currentVariant) => {
    const pehmeys_options = [pehmeys_type_1, pehmeys_type_2, pehmeys_type_3, pehmeys_type_4];
    //console.log("currentVariant: ", currentVariant)
    //if it is 0 then there's no pehmeys option  
    let pehmeys_options_index = 0; 
    for(let i = 1; i < 4; i++){
      if(pehmeys_options.includes(currentVariant[`option${i}`])){
        pehmeys_options_index = i;
        break;
      }
    }
    return pehmeys_options_index;
  }
  updatePehmeys() {
      const ff = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
      /* get index of option name that has Pehmeys */
      /* loop through pehmeys options 1,2,3 and see if any of them match the pehmeys type  */
      
      const pehmeys_type_1 = "Pehmeä";
      const pehmeys_type_2 = "Medium";
      const pehmeys_type_3 = "Tukeva";
      const pehmeys_type_4 = "Höyhen";
      const pehmeys_options_index = this.checkIfPehmeysInOptions(pehmeys_type_1, pehmeys_type_2, pehmeys_type_3, pehmeys_type_4, this.currentVariant);

      const pehmeys_type_1_richtext = "<p><strong>VALITSE PEHMEYS</strong></p><p><strong>Pehmeä</strong></p><p>Meillä pehmeät täytteet tarkoittavat medium-istuinta ja pehmeää selkätyynyä. Tämä yhdistelmä toimii niin leveissä kuin kapeammissakin istuintyynyissä. Sammaloitumisen vaaraa ei ole, sillä tästä sohvasta pääsee vielä ylös.</p><p>Medium-istuintyynyssä käytämme HR35-kimmovaahtoa. Pehmeä selkänoja sisältää Suomessa valmistettua ECOsupersoft-täytettä, jonka raaka-aine on 100% korkealaatuista, kierrätetyistä PET-pulloista valmistettua GRS-sertifioitua polyesterikuitua.</p>";
      const pehmeys_type_2_richtext = "<p><strong>VALITSE PEHMEYS</strong></p><p>Medium</p><p>Medium-täytteet antavat keholle lempeää tukea tuntumatta kuitenkaan liian kovilta. Tästä on helppo nousta ylös.</p><p>Medium-istuintyynyssä käytämme HR35-kimmovaahtoa, joka pitää kuosinsa myös leveissä tyynyissä. </p><p>Selkätyynyn valmistamiseen käytämme HR25EP-kimmovaahtoa.</p><p>Noin 36 % asiakkaistamme kulkee keskitietä ja valitsee sohvaansa medium-pehmeyden.</p>";
      const pehmeys_type_3_richtext = "<p><strong>VALITSE PEHMEYS</strong></p><p>Tukeva</p><p>Tukeva istuin antaa ryhdikkään tuen ja siitä on rotevammankin ukon ja rehevimmänkin akan helppo nousta ylös.</p><p>Tukevan istuimen valmistamiseen käytämme HR50-kimmovaahtoa.</p><p>Selkätyynyssä on HR25-kimmovaahtotäyte. </p><p>Noin 8 % asiakkaistamme haluaa sohvastaan tukevan istua ja valitsee siksi tukevat täytteet. </p>";
      const pehmeys_type_4_richtext = "<p><strong>VALITSE PEHMEYS</strong></p><p>Höyhentäyte</p><p>Höyhentäytteiset istuin- ja selkätyynyt ovat arjen luksusta ja ihanasti upottava pehmuste.</p><p>Höyhenistuimessa on ytimenä ERX40-kimmovaahto ja sen päällä koteloitu höyhenkerros. Höyhenet tulevat Lennolilta. </p><p>Höyhenselkätyynyjen valmistamiseen käytämme kotimaisen Lennolin Suomessa valmistamaa vaahtomuovinrouheen ja höyhenen sekoitusta. </p><p>Noin 36 % asiakkaistamme valitsee elämäänsä hitusen luksusta ja haluaa höyhentäytteet.</p>";

      const pehmeys_type_1_url_1 = "https://www.youtube.com/embed/12MB6rMmB2A";
      const pehmeys_type_1_url_2 = "https://www.youtube.com/embed/dzxee_4Su9k";
      const pehmeys_type_2_url_1 = "https://www.youtube.com/embed/KpmUkAKqfaI";
      const pehmeys_type_2_url_2 = "https://www.youtube.com/embed/KpmUkAKqfaI";
      const pehmeys_type_3_url_1 = "https://www.youtube.com/embed/D9dLFI8xi2Y";
      const pehmeys_type_3_url_2 = "https://www.youtube.com/embed/D9dLFI8xi2Y";
      const pehmeys_type_4_url_1 = "https://www.youtube.com/embed/l-bgMnH_RxQ";
      const pehmeys_type_4_url_2 = "https://www.youtube.com/embed/l-bgMnH_RxQ";
    if (pehmeys_options_index !== 0) {
      let pehmeys_content = "";
      if(this.currentVariant[`option${pehmeys_options_index}`] == pehmeys_type_1){
          pehmeys_content = pehmeys_type_1_richtext + this.GivePehmeysVideos(pehmeys_type_1_url_1, pehmeys_type_1_url_2);
      }
      else if(this.currentVariant[`option${pehmeys_options_index}`] == pehmeys_type_2){
          pehmeys_content = pehmeys_type_2_richtext + this.GivePehmeysVideos(pehmeys_type_2_url_1, pehmeys_type_2_url_2);
      }
      else if(this.currentVariant[`option${pehmeys_options_index}`] == pehmeys_type_3){
          pehmeys_content = pehmeys_type_3_richtext + this.GivePehmeysVideos(pehmeys_type_3_url_1, pehmeys_type_3_url_2);
      }
      else if(this.currentVariant[`option${pehmeys_options_index}`] == pehmeys_type_4){
          pehmeys_content = pehmeys_type_4_richtext + this.GivePehmeysVideos(pehmeys_type_4_url_1, pehmeys_type_4_url_2);
      }

      const pehmeys_div = document.getElementById(`pehmeys_content`);
      pehmeys_div.innerHTML = pehmeys_content;
    }
  }

  updateQuantityToggle() {
    const onlyShowQuantityOnFresco = document.getElementById("hidden-quantity-selector-metafields-container").innerHTML;
    //console.log("onlyShowQuantityOnFresco: ", onlyShowQuantityOnFresco)
    if(onlyShowQuantityOnFresco === "true") {
      const quantity_selector_fresco = document.getElementById("quantity_selector_fresco");
      //console.log("quantity_selector_fresco: ", quantity_selector_fresco)
      if(quantity_selector_fresco !== null) {
        var metafieldsData = JSON.parse(document.getElementById("hidden-variant-metafields-container").dataset.metafieldsData);
                //var variantsMetafields = JSON.parse($("#hidden-variant-metafields-container").dataset);
        //var variantsMetafields = jQuery.parseJSON($("#hidden-variant-metafields-container").html());
      //console.log("hello2: ", variantsMetafields)
      const ff = metafieldsData.find(elem => parseInt(elem.variant_id) === this.currentVariant.id)
        if (ff.metafield_value === "true") {
          document.getElementById("quantity_selector_fresco").style.display = "block";
        }
        else {
          document.getElementById("quantity_selector_fresco").style.display = "none";
        }
      }
    }

  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    if (!mediaGallery) return;

    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(':checked').value === variant.option1);
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue)
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  updateInventoryStatus() {
    this.productInventoryNode = document.querySelector('[data-product-inventory]');

    if (!this.productInventoryNode || !window.inventories || !window.inventories[this.dataset.productId]) return;

    this.inventoryThreshold = parseInt(this.productInventoryNode.dataset.threshold);
    this.showQuantityInStock = this.productInventoryNode.dataset.showQuantityInStock;

    const variantInventoryObject = window.inventories[this.dataset.productId][this.currentVariant?.id];

    if (!this.currentVariant || !this.currentVariant.inventory_management || variantInventoryObject.policy === 'continue') {
      this.toggleInventoryQuantity(false);
      this.toggleIncomingInventory(false);

      return;
    }

    if (this.currentVariant.inventory_management === 'shopify') {
      if (variantInventoryObject.policy === 'continue') {
        this.toggleInventoryQuantity(false);
        this.toggleIncomingInventory(false);
        
        return;
      }

      if (variantInventoryObject.quantity <= 0 && variantInventoryObject.incoming === 'true' && variantInventoryObject.quantity < this.inventoryThreshold) {
        this.toggleInventoryQuantity(false);
        this.toggleIncomingInventory(true, variantInventoryObject.next_incoming_date);
      } else {
        this.toggleInventoryQuantity(true, variantInventoryObject.quantity);
        this.toggleIncomingInventory(false);
      }
    }
  }

  toggleInventoryQuantity(show, quantity) {
    if (show === false) {
      this.productInventoryNode.classList.add('hide');
      return;
    }

    if (this.currentVariant && this.currentVariant.available && parseInt(quantity) <= parseInt(this.inventoryThreshold)) {
      this.productInventoryNode.classList.add('inventory-status--low');
      this.productInventoryNode.classList.remove('inventory-status--sold-out');

      if (!this.showQuantityInStock === 'true') {
        this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.few_left_with_quantity.replace('[quantity]', quantity);
      } else {
        this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.few_left;
      }
        
      this.productInventoryNode.classList.remove('hide');
    } else if (this.currentVariant && this.currentVariant.available && parseInt(quantity) > parseInt(this.inventoryThreshold)) {
      this.productInventoryNode.classList.remove('inventory-status--low', 'inventory-status--sold-out');
      if (!this.showQuantityInStock === 'true') {
        this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.in_stock_with_quantity.replace('[quantity]', quantity);
      } else {
        this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.in_stock;
      }
      this.productInventoryNode.classList.remove('hide');
    } else {
      this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.out_of_stock;
      this.productInventoryNode.classList.add('inventory-status--sold-out');
      this.productInventoryNode.classList.remove('hide');
    }
  }

  toggleIncomingInventory(show, date) {
    const incomingInventoryNode = document.querySelector('[data-incoming-inventory]');
    if (!incomingInventoryNode) return;

    if (show == false && incomingInventoryNode) {
      incomingInventoryNode.classList.add('hide');

      return;
    }

    let string = !date ?
      window.variantStrings.inventory.waiting_for_stock : 
      window.variantStrings.inventory.will_be_in_stock_after.replace('[date]', date);

    incomingInventoryNode.classList.remove('hide');
    incomingInventoryNode.firstElementChild.textContent = string;
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      if (this.dataset.isPreorder == 'true') {
        addButtonText.textContent = window.variantStrings.preOrder;
      } else {
        addButtonText.textContent = window.variantStrings.addToCart;
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });

    this.updateLegends();
  }

  updateLegends() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    fieldsets.forEach((fieldset) => {
      const legend = fieldset.querySelector('legend [data-variant-legend]');
      const selectedOption = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked);
      legend.textContent = selectedOption.getAttribute('value');
    });
  }
}

customElements.define('variant-radios', VariantRadios);

// Store product handles to history for "recently-viewed" section.
(function() {
  const history = sessionStorage.getItem('Woolman_Product_History') ? sessionStorage.getItem('Woolman_Product_History').split(',') : [];
  const productHandle = window.location.pathname.split('/').pop();
  if (!productHandle) return;
  if (!history.includes(productHandle)) {

    if (history.length >= 10) { // only store up to 10 recently viewed products
      history.shift();
    }
    
    history.push(productHandle);
    sessionStorage.setItem('Woolman_Product_History', history.join(','));
  }
})();

const Photoswipe = {
  attempts: 0,

  selectors: {
    images: '.photoswipe__image'
  },

  init: function() {
    document.querySelectorAll('.photoswipe__image').forEach(trigger => {
      trigger.addEventListener('click', this.downloadAndMount.bind(this));
    });
  },

  downloadAndMount: function(evt) {
    if (this.attempts >= 10) { return };
    this.attempts++;
    const existingScript = document.querySelector(`script[src="${theme.assets.photoswipe}"]`);

    // If we are already processing one slider, wait a while and try again.
    if (window.processingPhotoswipe) {
      setTimeout(this.downloadAndMount.bind(this), 200);
      return;
    }

    // Photoswipe script was already found in document, proceed to immediately mount slider
    if (existingScript) {
      this.showZoom(evt);
      return;
    }

    // Photoswipe script was not found in document, download it and wait for it to load, then show zoom
    window.processingPhotoswipe = true;

    const script = document.createElement('script');
    script.setAttribute('defer', 'true');
    script.setAttribute('async', 'true');
    script.src = theme.assets.photoswipe;
    document.body.append(script);

    script.addEventListener('load', () => {
      this.showZoom(evt)
    })
  },

  showZoom: function(evt) {
    const target = evt.currentTarget || evt.target;
    this.targetElement = target.closest('[data-photoswipe-parent]');
    this.items = this.getImageData();

    this.initGallery(this.items, target.dataset.index || 1);
    window.processingPhotoswipe = false;
  },

  getImageData: function() {
    this.images = this.targetElement.querySelectorAll(this.selectors.images)

    const items = [];
    
    this.images.forEach(el => {
      const item = {
        src: el.getAttribute('data-photoswipe-src'),
        w: parseInt(el.getAttribute('data-photoswipe-width')),
        h: parseInt(el.getAttribute('data-photoswipe-height')),
        initialZoomLevel: 0.5
      }

      items.push(item);
    });

    return items;
  },

  initGallery: function(items, index) {
    const pswpElement = document.querySelectorAll('.pswp')[0];

    const options = {
      allowPanToNext: false,
      captionEl: false,
      closeOnScroll: false,
      counterEl: false,
      history: false,
      index: parseInt(index) - 1,
      pinchToClose: false,
      preloaderEl: false,
      shareEl: false,
      tapToToggleControls: false
    }

    this.gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
    this.gallery.init();
  }
};
Photoswipe.init()